export enum FunnelChartColors {
    ConfidenceIntervalLine = "#cecece",
    BmAverageLine = "#434343",
    IsoLine = "#cecece",
    UpperRightQuadrant = "#EB2844",
    LowerLeftQuadrant = "#42c940",
}
